import React from 'react'
import ApiRequest from 'EurestoApi/ApiRequest'
import Grid from '@material-ui/core/Grid'
import Utils from 'EurestoFonction/Utils'

import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import EurestoDiv from 'EurestoComponents/EurestoDiv/index'

import Input from 'Components/Input'

const project = require('EurestoConfig/project.config')


class Documentation extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      documentationMemo: {},
      documentation: {},
      expanded: {},
      search: ''
    }
  }

  componentDidMount () {
    ApiRequest(project.api + 'commun', {
      requete: 'documentation',
      action: 'list'
    }, { showAlertError: false })
      .then((result) => {
        let expanded = {}
        Object.keys(result.documentation).map(requete => {
          expanded[requete] = false
          Object.keys(result.documentation[requete]).map(method => {
            expanded[requete + '_' + method] = false
          })
        })
        this.setState({
          documentationMemo: Object.assign({}, result.documentation),
          documentation: Object.assign({}, result.documentation),
          expanded: expanded
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  searchRequest = (data) => {
    const documentation = {}
    const doc = this.state.documentationMemo
    Object.keys(doc).map(mod => {
      documentation[mod] = {}
      Object.keys(doc[mod]).filter(req => req === 'url_api' || req.indexOf(data) !== -1).map((requete, i) => {
        documentation[mod][requete] = doc[mod][requete]
      })
    })

    this.setState({
      search: data,
      documentation: documentation
    })
  }

  getJson = params => {
    let json = {}
    params = {
      ...params.obligatoire || {},
      ...params.falcultatif || {},
    }

    Object.keys(params).map(key => {
      if (params[key].obligatoire || params[key].falcultatif) {
        if (params[key].type === 'ARRAY') {
          json[key] = [{
            ...this.getJson(params[key])
          }]
        } else {
          json[key] = {
            ...this.getJson(params[key])
          }
        }
      } else {
        json[key] = ''
      }
    })

    return json

  }

  onCopyClipBoard = (module, requete, action, params) => e => {
    e.preventDefault()
    e.stopPropagation()

    const json = this.getJson(params) || {}

    const textArea = document.createElement('textarea')
    textArea.value = JSON.stringify(json)
    document.body.appendChild(textArea)
    textArea.select()
    document.execCommand('Copy')
    textArea.remove()
  }

  render () {
    try {
      return (<Grid container
                    style={{
                      margin: 0,
                      padding: 0
                    }}
                    spacing={0}
                    alignItems='stretch'
                    wrap={'nowrap'}>
        <Grid item style={{
          margin: 0,
          padding: 0,
          position: 'relative',
          width: 350,
          minWidth: 350,
          //paddingTop: !(!this.props.forceUpdate === false || this.state.contact.action !== 'add') && 35,
        }}>
          <Input
            onChange={this.searchRequest}
            type="text"
            value={this.state.search}
            title={EurestoI18n.t('commun:Rechercher')}
          />
        </Grid>
        <Grid item xs style={{
          margin: 0,
          padding: 0
        }}>
          <Grid container spacing={0}
                style={{
                  margin: 0,
                  padding: 0
                }}
                justify='center'>
            <Grid item
                  style={{
                    margin: 0,
                    padding: 0
                  }}
                  xs={12}>
              <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
                {
                  Object.keys(this.state.documentation).filter(mod => Object.keys(this.state.documentation[mod]).filter(req => req !== 'url_api').length > 0).map(mod => {
                    return <EurestoDiv key={this.state.search + '-' + mod}
                                       title={'/' + this.state.documentation[mod].url_api} expandable={true}
                                       expanded={this.state.search !== ''}>
                      {Object.keys(this.state.documentation[mod]).filter(req => req !== 'url_api').map((requete, i) => {
                        return <Grid item style={{ margin: 0, padding: 0 }} xs={12}>
                          <EurestoDiv title={'requete: ' + requete} expandable={true}
                                      expanded={this.state.search !== ''}>
                            <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
                              {Object.keys(this.state.documentation[mod][requete]).map((method, i) => {
                                return <Grid item style={{ margin: 0, padding: 0 }} xs={12}>
                                  <ExpansionPanel>
                                    <ExpansionPanelSummary>
                                      <Typography><i className={'fa fa-copy'}
                                                     onClick={this.onCopyClipBoard(mod, requete, method, this.state.documentation[mod][requete][method].params)}/> {'action: ' + method}
                                      </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                      <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
                                        {
                                          <Grid item style={{ margin: 0, padding: 0 }} xs={12}>
                                            <Table>
                                              <TableHead>
                                                <TableRow>
                                                  <TableCell>Nom</TableCell>
                                                  <TableCell>Type</TableCell>
                                                  <TableCell>Détail</TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {this.state.documentation[mod][requete][method].params.obligatoire !== undefined
                                                && Object.keys(this.state.documentation[mod][requete][method].params.obligatoire).map(param => {
                                                  return <TableRow key={Utils.getRandomNumber()}
                                                                   style={{
                                                                     borderBottom: '2px solid ' + EurestoColor('EurestoError'),
                                                                     color: EurestoColor('EurestoError')
                                                                   }}>
                                                    <TableCell>{param}</TableCell>
                                                    <TableCell>{((this.state.documentation[mod][requete][method].params.obligatoire[param].type === 'ARRAY'
                                                      || this.state.documentation[mod][requete][method].params.obligatoire[param].type === 'OBJECT'
                                                      || this.state.documentation[mod][requete][method].params.obligatoire[param].type === 'TRADUCTION')
                                                      && this.state.documentation[mod][requete][method].params.obligatoire[param] !== undefined) ?
                                                      <div>{this.state.documentation[mod][requete][method].params.obligatoire[param].type}
                                                        {this.state.documentation[mod][requete][method].params.obligatoire[param] !== undefined
                                                        && this.state.documentation[mod][requete][method].params.obligatoire[param].obligatoire !== undefined
                                                        && Object.keys(this.state.documentation[mod][requete][method].params.obligatoire[param].obligatoire).map(p => {
                                                          return <TableRow key={Utils.getRandomNumber()} style={{
                                                            borderBottom: '2px solid ' + EurestoColor('EurestoError'),
                                                            color: EurestoColor('EurestoError')
                                                          }}>
                                                            <TableCell>{p}</TableCell>
                                                            <TableCell>{this.state.documentation[mod][requete][method].params.obligatoire[param].obligatoire[p].type}</TableCell>
                                                            <TableCell>{this.state.documentation[mod][requete][method].params.obligatoire[param].obligatoire[p].detail}</TableCell>
                                                          </TableRow>

                                                        })}

                                                        {this.state.documentation[mod][requete][method].params.obligatoire[param] !== undefined
                                                        && this.state.documentation[mod][requete][method].params.obligatoire[param].falcultatif !== undefined
                                                        && Object.keys(this.state.documentation[mod][requete][method].params.obligatoire[param].falcultatif).map(p => {
                                                          return <TableRow key={Utils.getRandomNumber()}>
                                                            <TableCell>{p}</TableCell>
                                                            <TableCell>{this.state.documentation[mod][requete][method].params.obligatoire[param].falcultatif[p].type}</TableCell>
                                                            <TableCell>{this.state.documentation[mod][requete][method].params.obligatoire[param].falcultatif[p].detail}</TableCell>
                                                          </TableRow>

                                                        })}
                                                      </div>
                                                      : this.state.documentation[mod][requete][method].params.obligatoire[param].type}</TableCell>
                                                    <TableCell>{this.state.documentation[mod][requete][method].params.obligatoire[param].detail}</TableCell>
                                                  </TableRow>

                                                })}

                                                {this.state.documentation[mod][requete][method].params.falcultatif !== undefined
                                                && Object.keys(this.state.documentation[mod][requete][method].params.falcultatif).map(param => {
                                                  return <TableRow key={Utils.getRandomNumber()}>
                                                    <TableCell>{param}</TableCell>
                                                    <TableCell>{((this.state.documentation[mod][requete][method].params.falcultatif[param].type === 'ARRAY'
                                                      || this.state.documentation[mod][requete][method].params.falcultatif[param].type === 'OBJECT'
                                                      || this.state.documentation[mod][requete][method].params.falcultatif[param].type === 'TRADUCTION')
                                                      && this.state.documentation[mod][requete][method].params.falcultatif[param] !== undefined) ?
                                                      <div>{this.state.documentation[mod][requete][method].params.falcultatif[param].type}
                                                        {this.state.documentation[mod][requete][method].params.falcultatif[param] !== undefined
                                                        && this.state.documentation[mod][requete][method].params.falcultatif[param].obligatoire !== undefined
                                                        && Object.keys(this.state.documentation[mod][requete][method].params.falcultatif[param].obligatoire).map(p => {
                                                          return <TableRow key={Utils.getRandomNumber()} style={{
                                                            borderBottom: '2px solid ' + EurestoColor('EurestoError'),
                                                            color: EurestoColor('EurestoError')
                                                          }}>
                                                            <TableCell>{p}</TableCell>
                                                            <TableCell>{this.state.documentation[mod][requete][method].params.falcultatif[param].obligatoire[p].type}</TableCell>
                                                            <TableCell>{this.state.documentation[mod][requete][method].params.falcultatif[param].obligatoire[p].detail}</TableCell>
                                                          </TableRow>

                                                        })}

                                                        {this.state.documentation[mod][requete][method].params.falcultatif[param] !== undefined
                                                        && this.state.documentation[mod][requete][method].params.falcultatif[param].falcultatif !== undefined
                                                        && Object.keys(this.state.documentation[mod][requete][method].params.falcultatif[param].falcultatif).map(p => {
                                                          return <TableRow key={Utils.getRandomNumber()}>
                                                            <TableCell>{p}</TableCell>
                                                            <TableCell>{this.state.documentation[mod][requete][method].params.falcultatif[param].falcultatif[p].type}</TableCell>
                                                            <TableCell>{this.state.documentation[mod][requete][method].params.falcultatif[param].falcultatif[p].detail}</TableCell>
                                                          </TableRow>

                                                        })}
                                                      </div> : this.state.documentation[mod][requete][method].params.falcultatif[param].type}</TableCell>
                                                    <TableCell>{this.state.documentation[mod][requete][method].params.falcultatif[param].detail}</TableCell>
                                                  </TableRow>
                                                })}
                                              </TableBody>
                                            </Table>
                                          </Grid>
                                        }
                                      </Grid>
                                    </ExpansionPanelDetails>
                                  </ExpansionPanel>
                                </Grid>
                              })}
                            </Grid>
                          </EurestoDiv>
                        </Grid>
                      })
                      }
                    </EurestoDiv>
                  })
                }
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>)
    } catch (err) {
      console.log(err)
      return <div>ERROR</div>
    }
  }
}

export default Documentation



// WEBPACK FOOTER //
// ./app/App/Module/Documentation/Page/Documentation/index.js